// extracted by mini-css-extract-plugin
module.exports = {"field-wrapper":"field-wrapper___1jrgi","label-box":"label-box___28jVJ","horizontal":"horizontal___sdkhH","required-field-icon":"required-field-icon___2XSZn"};